var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
//@ts-ignore
import OnReactIdle from '@modus/react-idle';
var OnIdle = function (props) {
    var _a = props.withSuspense, withSuspense = _a === void 0 ? true : _a, _b = props.placeholder, placeholder = _b === void 0 ? null : _b, children = props.children, _c = props.syncUpdate, syncUpdate = _c === void 0 ? true : _c, rest = __rest(props, ["withSuspense", "placeholder", "children", "syncUpdate"]);
    if (withSuspense) {
        return (_jsx(OnReactIdle, __assign({}, rest, { placeholder: placeholder, syncUpdate: syncUpdate }, { children: _jsx(Suspense, __assign({ fallback: placeholder }, { children: children }), void 0) }), void 0));
    }
    return _jsx(OnReactIdle, __assign({}, props), void 0);
};
export default OnIdle;
//# sourceMappingURL=index.js.map